<template>
  <v-dialog width="600" v-model="dialog" scrollable>
    <gg-card>
      <gg-toolbar @close="close">
        Add {{ type }} record for {{ domain }}
      </gg-toolbar>

      <gg-card-text>
        <record-hint :type="type" :domain="domain" :model="model"></record-hint>

        <a-record-form v-if="type === 'A'" @send-data="retrieveData"></a-record-form>
        <a-a-a-record-form v-else-if="type === 'AAAA'" @send-data="retrieveData"></a-a-a-record-form>
        <c-name-record-form v-else-if="type === 'CNAME'" @send-data="retrieveData"></c-name-record-form>
        <c-a-a-record-form v-else-if="type === 'CAA'" @send-data="retrieveData"></c-a-a-record-form>
        <s-r-v-record-form v-else-if="type === 'SRV'" @send-data="retrieveData"></s-r-v-record-form>
        <t-x-t-record-form v-else-if="type === 'TXT'" @send-data="retrieveData"></t-x-t-record-form>
        <m-x-record-form v-else-if="type === 'MX'"
                         :domain="domain"
                         @send-data="retrieveData"></m-x-record-form>
        <d-m-a-r-k-record-form v-else-if="type === 'DMARC'"
                               :domain="domain"
                               @send-data="retrieveData"></d-m-a-r-k-record-form>
      </gg-card-text>
      <v-card-actions class="justify-end">
        <gg-btn secondary @click="close">
          Close
        </gg-btn>
        <gg-btn :loading="loading" @click="addRecord">
          Add
        </gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'
import modalMixin from '@/mixins/modal'
import ARecordForm from './Records/ARecordForm'
import AAARecordForm from './Records/AAARecordForm'
import CNameRecordForm from './Records/CNameRecordForm'
import MXRecordForm from './Records/MXRecordForm'
import CAARecordForm from './Records/CAARecordForm'
import DMARKRecordForm from './Records/DMARKRecordForm'
import SRVRecordForm from './Records/SRVRecordForm'
import TXTRecordForm from './Records/TXTRecordForm'
import RecordHint from './RecordHint'

export default {
  name: 'AddRecordModal',
  mixins: [modalMixin],
  components: {
    ARecordForm,
    AAARecordForm,
    CNameRecordForm,
    MXRecordForm,
    CAARecordForm,
    DMARKRecordForm,
    SRVRecordForm,
    TXTRecordForm,
    RecordHint,
  },
  props: {
    domain: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    username: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      model: {},
      loading: false,
    }
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess']),
    async addRecord () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      let data = { _username: this.username || this.$route.query.user }
      switch (this.type) {
        case 'MX': {
          data['uapi_module'] = 'Email'
          data['uapi_function'] = 'add_mx'
          break
        }
        default: {
          data['api2_module'] = 'ZoneEdit'
          data['api2_method'] = 'add_zone_record'
          data['domain'] = this.domain
          this.type === 'DMARC' ? data['type'] = 'TXT' : data['type'] = this.type
          break
        }
      }
      for (let key in this.model) {
        if (this.model.hasOwnProperty(key)) {
          data[key] = this.model[key]
        }
      }
      try {
        switch (this.type) {
          case 'MX': {
            await amapi.cpanel_uapi(data)
            this.reportSuccess(
              `The following ${this.type} record for “${this.domain}” successfully added.`
            )
            this.loading = false
            this.close()
            this.$emit('action-completed', this.domain)
            break
          }
          default: {
            const res = await amapi.cpanel_api2(data)
            res.data.forEach(item => {
              if (!item.result.status) {
                this.loading = false
                this.reportError(item.result.statusmsg)
              } else {
                this.reportSuccess(
                  `The following ${this.type} record for “${this.domain}”: ${this.model.name} successfully added.`
                )
                this.loading = false
                this.close()
                this.$emit('action-completed', this.domain)
              }
            })
            break
          }
        }
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    retrieveData (payload) {
      this.model = { ...payload }
    }
  },
  provide () {
    // Validation
    return { parentValidator: this.$validator }
  }
}
</script>
